module.exports = __webpack_public_path__ + "img/lysk.59f6635f.jpg";